import { useState } from 'react';

// Stub - Moralis API removed. Implement with alternative API if needed.
const useTokenPrice = (options) => {
  const [tokenPrice, setTokenPrice] = useState(null);

  return { tokenPrice, isLoading: false, error: null };
};

export default useTokenPrice;
